import React from 'react'

import SharedComponent from './SharedComponent'

const EditComponent = (props) => <SharedComponent {...props} />

export default EditComponent
